import styled from 'styled-components';

import { Button } from '@xing-com/button';
import { ContentSwitcher } from '@xing-com/content-switcher';
import { mediaTopBarVisible } from '@xing-com/layout-tokens';
import { Tag } from '@xing-com/tag';
import { spaceS } from '@xing-com/tokens';
import { BodyCopy } from '@xing-com/typography';

const ContentSwitcherContainer = styled.div`
  padding-bottom: ${spaceS};
  width: 100%;
`;

const ContentSwitcherStyled = styled(ContentSwitcher)`
  width: 100%;
`;

const Filter = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${spaceS};
`;

const FilterLabel = styled(BodyCopy)`
  margin: 0 ${spaceS} 0 0;
`;

const FilterItem = styled(Tag)``;
const HeaderWithShuffleContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 32px;
  width: 100%;
`;

const ShuffleButton = styled(Button)`
  height: 60px;
  width: 60px;

  @media ${mediaTopBarVisible} {
    display: none;
  }
`;

const ShuffleTextButton = styled.div`
  flex: 1;
  justify-content: flex-start;
  @media ${mediaTopBarVisible} {
    display: none;
  }
`;

const MenuFilterContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  flex: 1;

  @media ${mediaTopBarVisible} {
    justify-content: center;
  }
`;

const MobileContainer = styled.div`
  display: none;

  @media ${mediaTopBarVisible} {
    display: block;
  }
`;

const DesktopContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  @media ${mediaTopBarVisible} {
    display: none;
  }
`;

export {
  ContentSwitcherContainer,
  ContentSwitcherStyled,
  FilterLabel,
  Filter,
  FilterItem,
  HeaderWithShuffleContainer,
  ShuffleButton,
  ShuffleTextButton,
  MenuFilterContainer,
  MobileContainer,
  DesktopContainer,
};
